<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container pt-3">
    <ngb-alert [type]="'info'" [dismissible]="false">
      If you are an implanter (eg Vet, Breeder, Rescue), please
      <a
        class="fw-bold"
        [href]="adminLoginUrl"
        target="_blank"
        rel="nofollow"
        >click here</a
      >
      to log into the admin site.
    </ngb-alert>

    <ngb-alert
      *ngIf="alert"
      [type]="alert.type"
      (closed)="closeAlert()"
      class="sticky-top mt-4"
      [class.bold]="alert.bold"
      style="top: 10px"
      ><span [innerHTML]="alert.message"></span
    ></ngb-alert>

    <div class="row mb-3">
      <div class="col-12">
        <h1 class="text-center" [ngClass]="{'page-title': useRebrandedLayout }">Log in</h1>
      </div>
    </div>

    <div class="row mb-2 d-flex justify-content-center">
      <div class="col-md-5 mb-3">
        <form #loginForm="ngForm" (ngSubmit)="login()" novalidate>
          <div [ngClass]="{'form-card h-100 p-4': useRebrandedLayout}">
            <div class="row mb-1 px-3" [ngClass]="'justify-content-end'">
              <mat-slide-toggle class="chip-checkbox w-auto px-0" [checked]="authWithChipNumber" (change)="onAuthWithChipNumberChanged($event)">Log in with chip number</mat-slide-toggle>
            </div>
            <div class="mb-1">
              <div>
                <label class="form-label mb-0" for="email">{{ authWithChipNumber ? 'Chip number' : 'Email address or phone number'}}</label>
              </div>
              <div>
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    [class.is-invalid]="email.touched && !email.valid"
                    id="email"
                    name="email"
                    [(ngModel)]="model.identifier"
                    [placeholder]="authWithChipNumber ? 'Enter chip number' : 'Enter email or phone number'"
                    (ngModelChange)="closeAlert()"
                    matInput
                    #email="ngModel"
                    required
                  />
                  <!--This next div is needed to make the input high enough-->
                  <div class="dummy-div" matSuffix></div>
                  <mat-error
                    *ngIf="(email.errors && email.errors.required)"
                  >
                    {{ errorStrings.required }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="mb-1">
              <div>
                <label class="form-label mb-0" for="password"> Password </label>
              </div>
              <div>
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    #password="ngModel"
                    [type]="hidePassword ? 'password' : 'text'"
                    id="password"
                    (ngModelChange)="closeAlert()"
                    name="password"
                    [(ngModel)]="model.password"
                    placeholder="Password"
                    required
                  />
                  <button
                    type="button"
                    mat-icon-button
                    matSuffix
                    (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hidePassword"
                  >
                    <mat-icon>{{
                      hidePassword ? "visibility_off" : "visibility"
                    }}</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>

            <div class="mb-3 text-end">
              <a
                routerLink="/forgot-password"
                [queryParams]="{ email: email.valid ? model.identifier : null }"
                >Forgot password?</a
              >
            </div>
            <div class="text-end">
              <a routerLink="/register">Don’t have an account yet? Sign Up</a>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-success text-white btn-lg w-100 mt-5"
            [disabled]="!loginForm.valid || loading || redirectTimer"
          >
            <fa-icon
              *ngIf="loading"
              [icon]="['fas', 'spinner']"
              [animation]="'spin'"
              class="me-3"
            ></fa-icon>
            {{ loading ? "Signing in..." : "Log in" }}
          </button>
        </form>
      </div>
    </div>

  </div>
</div>
